import EmailReader from '@admin/components/email_reader'
import Panel from '@admin/components/panel'
import Send from './send'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  component: <EmailReader email_campaign={ props.email_campaign } refresh={`/api/admin/campaigns/email/${props.email_campaign.id}/emails`} />,
  tasks: {
    items: [
      {
        label: 't(Send to Contact)',
        svg: 'user_round',
        modal: <Send email_campaign={ props.email_campaign } />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
